import { ReactNode, Ref } from 'react';

import { cn } from 'support/helpers/cn/cn';
import { FieldState } from 'support/types/ui';

const spanClassByState: Record<FieldState, string> = {
  default: 'text-gray-500',
  error: '',
  warning: '',
  'pending-validation': 'text-blue-500',
};

type LeadingAddOnProps = {
  leadingAddOn?: ReactNode | string;
  state?: FieldState;
  show: boolean;
  ref?: Ref<HTMLDivElement>;
};

export const LeadingAddOn = ({ leadingAddOn, state = 'default', show, ref }: LeadingAddOnProps) => {
  return (
    <div
      ref={ref}
      className={cn({
        'absolute inset-y-0 left-0 flex items-center pl-3': show,
        'pointer-events-none': typeof leadingAddOn === 'string' && show,
        'size-0': !show,
      })}
    >
      {show && leadingAddOn ? (
        <span
          className={cn(
            spanClassByState[state],
            'flex h-full items-center group-focus-within:text-gray-500 sm:text-sm',
          )}
        >
          {leadingAddOn}
        </span>
      ) : null}
    </div>
  );
};
